import { render, staticRenderFns } from "./MWmsLocationField.vue?vue&type=template&id=050be632&scoped=true&"
import script from "./MWmsLocationField.vue?vue&type=script&lang=js&"
export * from "./MWmsLocationField.vue?vue&type=script&lang=js&"
import style0 from "./m-wms.scss?vue&type=style&index=0&id=050be632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050be632",
  null
  
)

export default component.exports